import {IRoomRunFile} from '../../incase-domain/proptypes/IRoomRunFile';
import {
    RoomRunFileReducerType,
    UPDATE_ROOM_REDUCER,
    UPDATE_ROOM_RUN_FILE,
    UPDATE_ROOM_USER_COUNT,
} from '../actions/types/roomRunFile.actions.types';
import {IFetchRoom, RoomStatus} from '../../incase-domain/rooms/room.player';
import {IPresentation} from '../../incase-domain/presentation';
import {RESET_RUNFILE} from '../actions/types/runfile.actions.types';

export interface RoomRunFileReducerState {
    roomRunFile: IRoomRunFile;
    room: IFetchRoom;
    roomId: string;
    userCount: number;
}

export const preloadedState: RoomRunFileReducerState = {
    roomRunFile: {
        _id: '',
        ownerCurrentSlideIndex: 0,
        runFileId: '',
    },
    room: {
        roomId: '',
        roomStatus: RoomStatus.IDLE,
        presentationId: '',
        presenterId: '',
        isAllowed: false,
        isOwner: false,
        isPresenter: false,
        roomRunFileId: '',
        presentation: {} as IPresentation,
    },
    roomId: '',
    userCount: 0,
};

export const roomRunFileReducer = (
    state: RoomRunFileReducerState = preloadedState,
    action: RoomRunFileReducerType
): RoomRunFileReducerState => {
    switch (action.type) {
        case UPDATE_ROOM_REDUCER:
            return {
                ...state,
                room: action.room,
            };
        case UPDATE_ROOM_RUN_FILE:
            return {...state, roomRunFile: action.roomRunFile};
        case RESET_RUNFILE:
            return {...preloadedState};
        case UPDATE_ROOM_USER_COUNT:
            return {...state, userCount: action.payload};
        default:
            return state;
    }
};
